
import ProgressApi from '@/api/progress.js';
/**
 * 工具类
 */
let utils = {
  msgPrefix: {
    prod: '[vkshop后台]',
    test: '[vkshop后台-test]',
    dev: '[vkshop后台-dev]',
  },
  receiver: {
    prod: '姚金华;郑炜华;全建誉',
    test: '全建誉',
    dev: '全建誉',
  },
  WxCpErrorReport: {
    prod: true,
    test: false,
    dev: false,
  },
  XDebug: {
    prod: false,
    test: false,
    dev: true,
  },
  /**
   * 环境定义
   */
  ENV: {
    PROD: 'prod',
    TEST: 'test',
    DEV: 'dev',
  },
  /**
   * 根据环境获取不同的配置
   * @param env
   */
  getConfig(env = 'prod') {
    let WxCpErrorReport = this.WxCpErrorReport[env]
    let receiver = this.receiver[env]
    let msgPrefix = this.msgPrefix[env]
    let XDebug = this.XDebug[env]
    if (this.isArray(receiver)) {
      receiver = receiver.join('|')
    }
    if (process.env.NODE_ENV === 'development') {
      XDebug = true
    }
    return {
      // 调试参数
      XDebug,
      // 是否开启企业微信错误通知
      WxCpErrorReport,
      // 通知人员
      receiver,
      // 消息体前缀
      msgPrefix,
    }
  },
	/**
	 * scene解码
	 */
	scene_decode(e) {
		if (e === undefined)
			return {};
		let scene = decodeURIComponent(e),
			params = scene.split(','),
			data = {};
		for (let i in params) {
			var val = params[i].split(':');
			val.length > 0 && val[0] && (data[val[0]] = val[1] || null)
		}
		return data;
	},

	/**
	 * 格式化日期格式 (用于兼容ios Date对象)
	 */
	format_date(time) {
		// 将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
		return time.replace(/\-/g, "/");
	},

	/**
	 * 格式化详情内容,去除图片之间的间隙，图片宽度最大100%
	 */
	format_content(str) {
		return str.replace(/\<img/gi, '<img style="display:block; margin:0 auto; max-width:100%;" ');
	},
	/**
	 * 格式化文本域换行空格
	 * @param {Object} pretext
	 */
	preText(pretext) {
		return pretext.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
	},
	/**
	 * 对象转URL
	 */
	urlEncode(data) {
		var _result = [];
		for (var key in data) {
			var value = data[key];
			if (value.constructor == Array) {
				value.forEach(_value => {
					_result.push(key + "=" + _value);
				});
			} else {
				_result.push(key + '=' + value);
			}
		}
		return _result.join('&');
	},

	/**
	 * 遍历对象
	 */
	objForEach(obj, callback) {
		Object.keys(obj).forEach((key) => {
			callback(obj[key], key);
		});
	},

	/**
	 * 是否在数组内
	 */
	inArray(search, array) {
		for (let i in array) {
			if (array[i] == search) {
				return true;
			}
		}
		return false;
	},
	// 是否为字符串
	isString(str) {
		return typeof str === 'string' || str instanceof String;
	},
	// 是否为数组
	isArray(arg) {
		if (typeof Array.isArray === 'undefined') {
			return Object.prototype.toString.call(arg) === '[object Array]'
		}
		return Array.isArray(arg)
	},

	/**
	 * 发送企业微信消息
	 * @param receiver 消息接收人
	 * @param msg 消息文本
	 * @param groupName 群名称
	 * @param isNewGroup 是否强制建立新群
	 */
  sendWxCpMsg(receiver, msg, groupName = '', isNewGroup = false) {
    if (this.isArray(msg)) {
      msg = msg.join('\n')
    }
    if (this.isArray(receiver)) {
      receiver = receiver.join(';', receiver)
    }
    try {
      console.log("请求发送异常信息....")
      this.postRequest('https://msg.kemanduo.com.cn/msg', {receiver, msg, groupName, isNewGroup}, () => {}, () => {}, true)
    } catch (err) {
      console.log("发送...异常信息")
      console.log(err)
    }
  },

  /**
   * 异常消息处理发送通知
   */
  errHandler(error) {
    console.log('进入接口异常捕获')
    let msg = []
    msg.push(config.msgPrefix + '接口异常捕获')
    msg.push(`错误信息:${error.message}`)
    if (error && error.config) {
      msg.push(`请求方式:${error.config.method}`)
      msg.push(`接口地址:${error.config.url}`)
      console.log(error.config.params)
    }
    if (config.WxCpErrorReport && process.env.NODE_ENV === 'production') {
      this.sendWxCpMsg(config.receiver, msg)
    }
  },

	/**
	 * 判断是否为正整数
	 */
	isPositiveInteger(value) {
		return /(^[0-9]\d*$)/.test(value);
	},
  handleResponse(xhr, success, failure) {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      console.log("--------readyState------", xhr.readyState, xhr.status)
      if (xhr.status === 200) {
        if (success !== null && success !== undefined) {
          let result = xhr.responseText
          try {
            success(result, JSON.parse(result));
          } catch (e) {
            success(result, {});
          }
        }
      } else {
        if (failure !== null && failure !== undefined) {
          console.log("error status", xhr.responseText, xhr.status)
          failure(xhr.responseText, xhr.status)
        }
      }
    }
  },
  postRequest(url, arg, success, failure, async) {
    console.log("==========jsPostJSON>>>>>>>>>>>>>>>>==========", url)
    let self = this
    let xhr = new XMLHttpRequest
    xhr.open("POST", url, async)
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
    let requestData = ''
    for(let name in arg) {
      requestData += name + '='+ arg[name] + '&'
    }
    requestData = requestData == '' ? '' : requestData.substring(0,requestData.length - 1)
    xhr.onreadystatechange = function () {
      self.handleResponse(xhr, success, failure)
    }
    xhr.send(requestData)
  },
  //增加定时查询任务情况接口
  setInterval_timer(obj,callback,time){
    var timer =  setInterval(() => {
      if(obj.process_code != ""){
          ProgressApi.getProgress(obj).then(data => {
            if( data.data.status == 1){
                callback(100,timer,data.data.totalTime)
            }else{
              callback(parseInt(data.data.percentage),timer,data.data.totalTime)
            }
        }).catch(error => {
              callback(-1,timer,0)
        });
        }
    }, time);

  },
  reqTask(self,axios,token,percentage,process_code,formInline,AnalysisApi,callback,inter,smsTaskId=""){//执行任务请求
    console.log("token",token)
    AnalysisApi[inter]({
        formInline:JSON.stringify(formInline),
        process_code: process_code,
        sms_task_id:smsTaskId
      },{
        cancelToken: token
      }).then(data => {
        if(data.data.status == 1){//已经完成
            callback(1,"")
        }else if(data.data.status == -2){//中断方法重新调用  保证一个连接不超时
          if(percentage < 100){
              callback(-2, data.data.val)
          }else{//大于进度条不再调用
              callback(1,"")
          }
        }
      }).catch(error => {//错误不再调用
        if (axios.isCancel(error)) {
            callback(1,"")
            self.$message({
                type: 'error',
                message:error.message
            });
        }else{//处理错误
          callback(error.code,"")
        }
    });
},
monitorTask(percentage,callback,process_code){//监听任务
  if(percentage < 100){
    this.setInterval_timer({
      process_code:process_code
    },function(res1,res2,res3){
      console.log(res2)
      if(res1 == -1 || res1 == 100){
            callback(-1,0,res2,res3);// //任务结束执行的代码
        }else{//继续执行
            callback(1,res1,res2,res3)
        }
    },2000);
  }

},createordernum() {//生成唯一订单
  const now = new Date()
  let month = now.getMonth() + 1
  let day = now.getDate()
  let hour = now.getHours()
  let minutes = now.getMinutes()
  let seconds = now.getSeconds()
  month = this.setTimeDateFmt(month)
  day = this.setTimeDateFmt(day)
  hour = this.setTimeDateFmt(hour)
  minutes = this.setTimeDateFmt(minutes)
  seconds = this.setTimeDateFmt(seconds)
  let orderCode = now.getFullYear().toString() + month.toString() + day + hour + minutes + seconds + (Math.round(Math.random() * 1000000)).toString();
  return orderCode;
  //基于年月日时分秒+随机数生成订单编号
},
 setTimeDateFmt(s) {  // 个位数补齐十位数
  return s < 10 ? '0' + s : s;
}

}

export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js